<div class="py-4 px-0">
  <div class="container">
    <h1>{{ "search.title" | translate }}</h1>

    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="form-search">
      <div class="mb-4">
        <div class="input-group mb-2">
          <label class="visually-hidden" for="keywords">{{ "search.inputs.keywords.label" | translate }}</label>
          <input
            type="search"
            [maxLength]="255"
            class="form-control"
            id="keywords"
            [placeholder]="'search.inputs.keywords.placeholder' | translate"
            formControlName="keywords" />

          <button type="submit" class="btn btn-blue" id="button-search">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span class="visually-hidden">{{ "search.inputs.submit.sr-text" | translate }}</span>
          </button>
        </div>

        @if (keywordsCtrl.invalid) {
          <small class="text-danger">{{ "search.errors.keywords" | translate }}</small>
        }

        @if (usedFilters.length > 0) {
          <div class="selected-search-filters">
            <span id="used-filters-label" class="me-1">{{ "search.filters.usedFilters" | translate }}</span>
            @for (filter of usedFilters; track filter) {
              <span
                class="badge badge-gray search-filter"
                aria-labelledby="used-filters-label">
                <button type="button" class="btn btn-light" (click)="onSubmit(filter)">
                  <span aria-hidden="true">&times;</span>
                  <span class="visually-hidden">{{ "forms.common.delete" | translate }}</span>
                </button>
                {{ filter.value }}
              </span>
            }
          </div>
        }
      </div>

      <div class="row">
        <div class="col-lg-3 mb-2 mb-md-0" id="filters" formGroupName="filters">
          <div class="block-header">
            <div
              class="header"
              role="button"
              [attr.aria-expanded]="!isCollapsedFilters"
              [attr.aria-controls]="searchFilters ? 'search-filters' : null"
              (click)="isCollapsedFilters = !isCollapsedFilters"
              (keydown.enter)="isCollapsedFilters = !isCollapsedFilters"
              (keydown.space)="isCollapsedFilters = !isCollapsedFilters"
              tabindex="0">
              <div class="row align-items-center">
                <div class="col">
                  <h2>{{ "search.results.narrowSearch" | translate }}</h2>
                </div>

                <div class="col-auto">
                  @if (filtersCount > 0) {
                    <span class="badge rounded-pill badge-blue me-2">{{ filtersCount }}</span>
                  }

                  <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedFilters ? 'fa-plus' : 'fa-minus'"></i>
                </div>
              </div>
            </div>
          </div>

          @if (searchFilters) {
            <div
              id="search-filters"
              [collapse]="isCollapsedFilters"
              [isAnimated]="true">
              @if (languagesArray.controls.length > 0 && allLanguages) {
                <div class="filter" formArrayName="languages">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedLanguages"
                    aria-controls="filter-languages"
                    (click)="isCollapsedLanguages = !isCollapsedLanguages"
                    (keydown.enter)="isCollapsedLanguages = !isCollapsedLanguages"
                    (keydown.space)="isCollapsedLanguages = !isCollapsedLanguages"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="filter-header" id="filter-languages-header">
                          {{ "search.filters.languages.title" | translate }}
                        </h3>
                      </div>
                      <div class="col-auto">
                        @if (languagesCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">
                            {{ languagesCount }}
                          </span>
                        }
                        <i
                          class="fa fa-fw"
                          aria-hidden="true"
                        [ngClass]="isCollapsedLanguages ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-languages"
                    aria-labelledby="filter-languages-header"
                    [collapse]="isCollapsedLanguages"
                    [isAnimated]="true">
                    @for (
                      language of languagesArray.controls | slice: 0:filtersShown.get('languages'); track
                      language; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="languages-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="languages-{{ i }}">
                          {{ getLanguageLabel(searchFilters.languages[i]) }}
                        </label>
                      </div>
                    }
                    @if (showAllLanguages) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('languages', languagesArray.controls.length); showAllLanguages = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/languages-->
              <div class="filter" formArrayName="educationalLevels">
                <div
                  class="header"
                  role="button"
                  [attr.aria-expanded]="!isCollapsedLevels"
                  aria-controls="filter-levels"
                  (click)="isCollapsedLevels = !isCollapsedLevels"
                  (keydown.enter)="isCollapsedLevels = !isCollapsedLevels"
                  (keydown.space)="isCollapsedLevels = !isCollapsedLevels"
                  tabindex="0">
                  <div class="row align-items-center">
                    <div class="col">
                      <h3 id="filter-levels-header">{{ "search.filters.educationalLevels.title" | translate }}</h3>
                    </div>
                    <div class="col-auto">
                      @if (educationalLevelsCount > 0) {
                        <span class="badge rounded-pill badge-blue me-2">
                          {{ educationalLevelsCount }}
                        </span>
                      }
                      <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedLevels ? 'fa-plus' : 'fa-minus'"></i>
                    </div>
                  </div>
                </div>
                <div
                  class="content"
                  role="group"
                  id="filter-levels"
                  aria-labelledby="filter-levels-header"
                  [collapse]="isCollapsedLevels"
                  [isAnimated]="true">
                  @for (level of educationalLevelsArray.controls; track level; let i = $index) {
                    <ng-container [formGroupName]="i">
                      <h5>{{ educationalLevels[i].value }}</h5>
                      <div class="children" formArrayName="levels">
                        @for (child of levelChildrenControls(level); track child; let j = $index) {
                          <div
                            class="form-check"
                            >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="educationalLevels-{{ i }}-{{ j }}"
                              [formControlName]="j" />
                            <label class="form-check-label" for="educationalLevels-{{ i }}-{{ j }}">
                              {{ educationalLevels[i].children[j].value }}
                            </label>
                          </div>
                        }
                      </div>
                    </ng-container>
                  }
                </div>
              </div>
              <!--/educationalLevels-->
              @if (subjectsArray.controls.length > 0) {
                <div class="filter" formArrayName="educationalSubjects">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedSubjects"
                    aria-controls="filter-subjects"
                    (click)="isCollapsedSubjects = !isCollapsedSubjects"
                    (keydown.enter)="isCollapsedSubjects = !isCollapsedSubjects"
                    (keydown.space)="isCollapsedSubjects = !isCollapsedSubjects"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-subjects-header">{{ "search.filters.educationalSubjecs.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (subjectsCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ subjectsCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedSubjects ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-subjects"
                    aria-labelledby="filter-subjects-header"
                    [collapse]="isCollapsedSubjects"
                    [isAnimated]="true">
                    @for (subject of subjectsArray.controls | slice: 0:filtersShown.get('subjects'); track subject; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="subjects-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="subjects-{{ i }}">
                          {{ searchFilters.subjects[i].value }}
                        </label>
                      </div>
                    }
                    @if (showAllSubjects) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('subjects', subjectsArray.controls.length); showAllSubjects = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/educationalSubjects-->
              @if (teachesArray.controls.length > 0) {
                <div class="filter" formArrayName="teaches">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedTeaches"
                    aria-controls="filter-teaches"
                    (click)="isCollapsedTeaches = !isCollapsedTeaches"
                    (keydown.enter)="isCollapsedTeaches = !isCollapsedTeaches"
                    (keydown.space)="isCollapsedTeaches = !isCollapsedTeaches"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-teaches-header">{{ "search.filters.teaches.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (teachesCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ teachesCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedTeaches ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-teaches"
                    aria-labelledby="filter-teaches-header"
                    [collapse]="isCollapsedTeaches"
                    [isAnimated]="true">
                    @for (teach of teachesArray.controls | slice: 0:filtersShown.get('teaches'); track teach; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="teaches-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="teaches-{{ i }}">
                          {{ searchFilters.teaches[i].value | truncate: [teachesTruncates.get(i)] }}
                        </label>
                        @if (searchFilters.teaches[i].value.length > teachesTruncates.get(i)) {
                          <button
                            type="button"
                            class="btn btn-link btn-sm"
                            (click)="teachesTruncates.set(i, searchFilters.teaches[i].value.length)">
                            {{ "search.filters.teaches.showFull" | translate }}
                          </button>
                        }
                      </div>
                    }
                    @if (showAllTeaches) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('teaches', teachesArray.controls.length); showAllTeaches = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/teaches-->
              <div class="filter" formArrayName="learningResourceTypes">
                <div
                  class="header"
                  role="button"
                  [attr.aria-expanded]="!isCollapsedTypes"
                  aria-controls="filter-types"
                  (click)="isCollapsedTypes = !isCollapsedTypes"
                  (keydown.enter)="isCollapsedTypes = !isCollapsedTypes"
                  (keydown.space)="isCollapsedTypes = !isCollapsedTypes"
                  tabindex="0">
                  <div class="row align-items-center">
                    <div class="col">
                      <h3 id="filter-types-header">{{ "search.filters.learningResourceTypes.title" | translate }}</h3>
                    </div>
                    <div class="col-auto">
                      @if (learningResourceTypesCount > 0) {
                        <span class="badge rounded-pill badge-blue me-2">
                          {{ learningResourceTypesCount }}
                        </span>
                      }
                      <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedTypes ? 'fa-plus' : 'fa-minus'"></i>
                    </div>
                  </div>
                </div>
                <div
                  class="content"
                  role="group"
                  id="filter-types"
                  aria-labelledby="filter-types-header"
                  [collapse]="isCollapsedTypes"
                  [isAnimated]="true">
                  @for (type of learningResourceTypesArray.controls; track type; let i = $index) {
                    <div
                      class="form-check"
                      >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="learningResourceTypes-{{ i }}"
                        [formControlName]="i" />
                      <label class="form-check-label" for="learningResourceTypes-{{ i }}">
                        {{ learningResourceTypes[i].value }}
                      </label>
                    </div>
                  }
                </div>
              </div>
              <!--/learningResourceTypes-->
              @if (authorsArray.controls.length > 0) {
                <div class="filter" formArrayName="authors">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedAuthors"
                    aria-controls="filter-authors"
                    (click)="isCollapsedAuthors = !isCollapsedAuthors"
                    (keydown.enter)="isCollapsedAuthors = !isCollapsedAuthors"
                    (keydown.space)="isCollapsedAuthors = !isCollapsedAuthors"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-authors-header">{{ "search.filters.authors.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (authorsCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ authorsCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedAuthors ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-authors"
                    aria-labelledby="filter-authors-header"
                    [collapse]="isCollapsedAuthors"
                    [isAnimated]="true">
                    @for (author of authorsArray.controls | slice: 0:filtersShown.get('authors'); track author; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="authors-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="authors-{{ i }}">{{ searchFilters.authors[i] }}</label>
                      </div>
                    }
                    @if (showAllAuthors) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('authors', authorsArray.controls.length); showAllAuthors = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/authors-->
              @if (organizationsArray.controls.length > 0) {
                <div class="filter" formArrayName="organizations">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedOrganizations"
                    aria-controls="filter-organizations"
                    (click)="isCollapsedOrganizations = !isCollapsedOrganizations"
                    (keydown.enter)="isCollapsedOrganizations = !isCollapsedOrganizations"
                    (keydown.space)="isCollapsedOrganizations = !isCollapsedOrganizations"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-organizations-header">{{ "search.filters.organizations.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (organizationsCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">
                            {{ organizationsCount }}
                          </span>
                        }
                        <i
                          class="fa fa-fw"
                          aria-hidden="true"
                        [ngClass]="isCollapsedOrganizations ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-organizations"
                    aria-labelledby="filter-organizations-header"
                    [collapse]="isCollapsedOrganizations"
                    [isAnimated]="true">
                    @for (
                      organization of organizationsArray.controls | slice: 0:filtersShown.get('organizations'); track
                      organization; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="organizations-{{ i }}"
                          [formControlName]="i" />
                        <label class="form-check-label" for="organizations-{{ i }}">
                          {{ searchFilters.organizations[i].value }}
                        </label>
                      </div>
                    }
                    @if (showAllOrganizations) {
                      <button
                        type="button"
                        class="btn btn-link"
                  (click)="
                    filtersShown.set('organizations', organizationsArray.controls.length); showAllOrganizations = false
                  "
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/organizations-->
              @if (educationalRolesArray.controls.length > 0) {
                <div class="filter" formArrayName="educationalRoles">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedRoles"
                    aria-controls="filter-roles"
                    (click)="isCollapsedRoles = !isCollapsedRoles"
                    (keydown.enter)="isCollapsedRoles = !isCollapsedRoles"
                    (keydown.space)="isCollapsedRoles = !isCollapsedRoles"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-roles-header">{{ "search.filters.educationalRoles.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (educationalRolesCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">
                            {{ educationalRolesCount }}
                          </span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedRoles ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-roles"
                    aria-labelledby="filter-roles-header"
                    [collapse]="isCollapsedRoles"
                    [isAnimated]="true">
                    @for (
                      role of educationalRolesArray.controls | slice: 0:filtersShown.get('roles'); track
                      role; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="educationalRoles-{{ i }}"
                          [formControlName]="i" />
                        <label class="form-check-label" for="educationalRoles-{{ i }}">
                          {{ searchFilters.roles[i].value }}
                        </label>
                      </div>
                    }
                    @if (showAllRoles) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('roles', educationalRolesArray.controls.length); showAllRoles = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/educationalRoles-->
              @if (keywordsArray.controls.length > 0) {
                <div class="filter" formArrayName="keywords">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedKeywords"
                    aria-controls="filter-keywords"
                    (click)="isCollapsedKeywords = !isCollapsedKeywords"
                    (keydown.enter)="isCollapsedKeywords = !isCollapsedKeywords"
                    (keydown.space)="isCollapsedKeywords = !isCollapsedKeywords"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-keywords-header">{{ "search.filters.keywords.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (keywordsCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ keywordsCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedKeywords ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-keywords"
                    aria-labelledby="filter-keywords-header"
                    [collapse]="isCollapsedKeywords"
                    [isAnimated]="true">
                    @for (keyword of keywordsArray.controls | slice: 0:filtersShown.get('keywords'); track keyword; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="keywords-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="keywords-{{ i }}">
                          {{ searchFilters.keywords[i].value }}
                        </label>
                      </div>
                    }
                    @if (showAllKeywords) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('keywords', keywordsArray.controls.length); showAllKeywords = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/keywords-->
              @if (usesArray.controls.length > 0) {
                <div class="filter" formArrayName="educationalUses">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedUses"
                    aria-controls="filter-uses"
                    (click)="isCollapsedUses = !isCollapsedUses"
                    (keydown.enter)="isCollapsedUses = !isCollapsedUses"
                    (keydown.space)="isCollapsedUses = !isCollapsedUses"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-uses-header">{{ "search.filters.uses.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (usesCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ usesCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedUses ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-uses"
                    aria-labelledby="filter-uses-header"
                    [collapse]="isCollapsedUses"
                    [isAnimated]="true">
                    @for (use of usesArray.controls | slice: 0:filtersShown.get('uses'); track use; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="uses-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="uses-{{ i }}">{{ searchFilters.uses[i].value }}</label>
                      </div>
                    }
                    @if (showAllUses) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('uses', usesArray.controls.length); showAllUses = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/educationalUses-->
              @if (hazardsArray.controls.length > 0) {
                <div class="filter" formArrayName="accessibilityHazards">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedHazards"
                    aria-controls="filter-hazards"
                    (click)="isCollapsedHazards = !isCollapsedHazards"
                    (keydown.enter)="isCollapsedHazards = !isCollapsedHazards"
                    (keydown.space)="isCollapsedHazards = !isCollapsedHazards"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-hazards-header">{{ "search.filters.hazards.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (hazardsCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ hazardsCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedHazards ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-hazards"
                    aria-labelledby="filter-hazards-header"
                    [collapse]="isCollapsedHazards"
                    [isAnimated]="true">
                    @for (hazards of hazardsArray.controls | slice: 0:filtersShown.get('hazards'); track hazards; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="hazards-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="hazards-{{ i }}">{{ searchFilters.hazards[i].value }}</label>
                      </div>
                    }
                    @if (showAllHazards) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('hazards', hazardsArray.controls.length); showAllHazards = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/accessibilityHazards-->
              @if (featuresArray.controls.length > 0) {
                <div class="filter" formArrayName="accessibilityFeatures">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedFeatures"
                    aria-controls="filter-features"
                    (click)="isCollapsedFeatures = !isCollapsedFeatures"
                    (keydown.enter)="isCollapsedFeatures = !isCollapsedFeatures"
                    (keydown.space)="isCollapsedFeatures = !isCollapsedFeatures"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-features-header">{{ "search.filters.features.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (featuresCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ featuresCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedFeatures ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-features"
                    aria-labelledby="filter-features-header"
                    [collapse]="isCollapsedFeatures"
                    [isAnimated]="true">
                    @for (feature of featuresArray.controls | slice: 0:filtersShown.get('features'); track feature; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="features-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="features-{{ i }}">
                          {{ searchFilters.features[i].value }}
                        </label>
                      </div>
                    }
                    @if (showAllFeatures) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('features', featuresArray.controls.length); showAllFeatures = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/accessibilityFeatures-->
              @if (licensesArray.controls.length > 0) {
                <div class="filter" formArrayName="licenses">
                  <div
                    class="header"
                    role="button"
                    [attr.aria-expanded]="!isCollapsedLicenses"
                    aria-controls="filter-licenses"
                    (click)="isCollapsedLicenses = !isCollapsedLicenses"
                    (keydown.enter)="isCollapsedLicenses = !isCollapsedLicenses"
                    (keydown.space)="isCollapsedLicenses = !isCollapsedLicenses"
                    tabindex="0">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 id="filter-licenses-header">{{ "search.filters.licenses.title" | translate }}</h3>
                      </div>
                      <div class="col-auto">
                        @if (licensesCount > 0) {
                          <span class="badge rounded-pill badge-blue me-2">{{ licensesCount }}</span>
                        }
                        <i class="fa fa-fw" aria-hidden="true" [ngClass]="isCollapsedLicenses ? 'fa-plus' : 'fa-minus'"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="content"
                    role="group"
                    id="filter-licenses"
                    aria-labelledby="filter-licenses-header"
                    [collapse]="isCollapsedLicenses"
                    [isAnimated]="true">
                    @for (license of licensesArray.controls | slice: 0:filtersShown.get('licenses'); track license; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input type="checkbox" class="form-check-input" id="licenses-{{ i }}" [formControlName]="i" />
                        <label class="form-check-label" for="licenses-{{ i }}">
                          {{ searchFilters.licenses[i].value }}
                        </label>
                      </div>
                    }
                    @if (showAllLicenses) {
                      <button
                        type="button"
                        class="btn btn-link"
                        (click)="filtersShown.set('licenses', licensesArray.controls.length); showAllLicenses = false"
                        >
                        {{ "search.filters.showAll" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
              <!--/licenses-->
              @if (filtersCount > 50) {
                <small class="text-danger">{{ "search.errors.filters" | translate }}</small>
              }
            </div>
          } @else {
            @if (results?.hits > 0) {
              <div class="filter">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">{{ "search.results.loading" | translate }}</span>
                </div>
              </div>
            }
          }

          <button type="submit" class="btn btn-blue w-100" id="button-narrow-search">
            {{ "search.filters.submit" | translate }}
          </button>
        </div>
        <!--/filters-->
        <div class="col-lg-9">
          @if (loading) {
            <div>
              <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
            </div>
          } @else {
            @if (results?.hits > 0) {
              <div id="results" #resultsContainer>
                <div class="block-header">
                  <div class="row justify-content-md-between align-items-md-center mb-2">
                    <div class="col-md-4 text-center text-md-start">
                      <div class="results-count mb-2 mb-md-0" aria-live="polite">
                        {{ from + 1 }} - {{ page * resultsPerPage <= results.hits ? page * resultsPerPage : results.hits
                        }} / {{ results.hits }} {{ "search.results.results" | translate }}
                      </div>
                    </div>
                    <div class="col-md-auto">
                      <div class="form-group mb-0">
                        <label for="sort" class="visually-hidden">{{ "search.sort.label" | translate }}</label>
                        <select
                          class="form-control aoe-select-search-sort"
                          id="sort"
                          formControlName="sort"
                          (change)="onSubmit()">
                          <option [ngValue]="sortOptions.relevance.value">
                            {{ "search.sort.relevance" | translate }}
                          </option>
                          <option [ngValue]="sortOptions.newest.value">{{ "search.sort.newest" | translate }}</option>
                          <option [ngValue]="sortOptions.oldest.value">{{ "search.sort.oldest" | translate }}</option>
                          <option [ngValue]="sortOptions.popularity.value">
                            {{ "search.sort.popularity" | translate }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-center">
                      <pagination-controls
                        (pageChange)="getPage($event)"
                        class="search-pagination"
                        [previousLabel]="'forms.common.previous' | translate"
                      [nextLabel]="'forms.common.next' | translate"></pagination-controls>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    @if (loading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                    } @else {
                      @for (
                        result of results.results
                        | paginate: { itemsPerPage: resultsPerPage, currentPage: page, totalItems: results.hits }
                        ; track
                        result) {
                        <app-search-result
                          [result]="result"
                        (executeFilteredSearch)="filterSearch()"></app-search-result>
                      }
                    }
                    <!--loading-->
                  </div>
                </div>
                <div class="block-header">
                  <div class="row justify-content-md-between align-items-md-center mb-2">
                    <div class="col-md-4 text-center text-md-start">
                      <div class="results-count mb-2 mb-md-0">
                        {{ from + 1 }} - {{ page * resultsPerPage <= results.hits ? page * resultsPerPage : results.hits
                        }} / {{ results.hits }} {{ "search.results.results" | translate }}
                      </div>
                    </div>
                    <div class="col-md-auto">
                      <div class="form-group mb-0">
                        <label for="sort2" class="visually-hidden">{{ "search.sort.label" | translate }}</label>
                        <select
                          class="form-control aoe-select-search-sort"
                          id="sort2"
                          formControlName="sort2"
                          (change)="onSubmit()">
                          <option [ngValue]="sortOptions.relevance.value">
                            {{ "search.sort.relevance" | translate }}
                          </option>
                          <option [ngValue]="sortOptions.newest.value">{{ "search.sort.newest" | translate }}</option>
                          <option [ngValue]="sortOptions.oldest.value">{{ "search.sort.oldest" | translate }}</option>
                          <option [ngValue]="sortOptions.popularity.value">
                            {{ "search.sort.popularity" | translate }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-center">
                      <pagination-controls
                        (pageChange)="getPage($event)"
                        class="search-pagination"
                        [previousLabel]="'forms.common.previous' | translate"
                      [nextLabel]="'forms.common.next' | translate"></pagination-controls>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <p>{{ "search.results.noResults" | translate }}</p>
            }
          }

          <ng-template #loadingTemplate>
            <div class="d-flex align-items-center">
              <strong>{{ "search.results.loading" | translate }}</strong>
              <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
            </div>
          </ng-template>
        </div>
      </div>
    </form>
  </div>
</div>
